export default (payload) => ({
  type: 'UPDATE_LOANS_STATE',
  payload,
});
